import { GET_ORDER_CONTACT_INFO } from '../actionTypes/OrderActionTypes';

export default function OrderContactInfoReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_CONTACT_INFO:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
